$shm_hitalama_guide_panel $mol_book2
	section \knowledge
	param \guide
	menu_title \Руководство пользователя
	pages <= guide_pages /$mol_view
	Page $mol_page
		title <= title \Руководство пользователя
		minimal_width 420
		title_content /
			<= Header_title $mol_view
				sub <= heading /$mol_view_content
			<= Edit $mol_check_icon
				hint \Редактировать страницу
				enabled <= editable false
				checked? <=> editing? false
				Icon <= Edit_icon $mol_icon_pencil
		tools /
			<= Close $mol_button_minor
				hint \Закрыть руководство
				click? <=> close? null
				sub / <= Close_icon $mol_icon_close
		body /
			<= Text $shm_hitalama_guide_text
				text <= text \
				page_uri* <= page_uri* \
	Crumb* $mol_link
		arg <= crumb_arg* *
		title <= crumb_title* \
	Header_label $mol_view
		sub / <= title
	Editor $shm_hitalama_guide_editor
		catalog <= catalog $shm_hitalama_guide_catalog
		id <= selected \
		opened? <=> editing?
